// @ts-nocheck
(function () {
	// 現在のscriptタグからclinic-idを読み取る関数
	function getClinicIdFromScript() {
		// 1. 現在実行中のscriptを取得（最も確実）
		let currentScript = document.currentScript;

		// 2. currentScriptが取得できない場合は判別用属性で検索
		if (!currentScript) {
			currentScript = document.querySelector('script[data-booking-widget-loader]');
		}

		// 3. フォールバック: URLパターンでの検索
		if (!currentScript) {
			currentScript = document.querySelector('script[src*="booking-widget-loader.js"]');
		}

		return currentScript ? currentScript.getAttribute('data-clinic-id') : null;
	}

	// 現在のscriptタグから store（キレイレポ本体）clinic-id を読み取る関数。
	// アプリのディープリンク着地・画面別計測が期待する ID 体系（widget内部IDではなく本体ID）。
	function getStoreClinicIdFromScript() {
		let currentScript = document.currentScript;
		if (!currentScript) {
			currentScript = document.querySelector('script[data-booking-widget-loader]');
		}
		if (!currentScript) {
			currentScript = document.querySelector('script[src*="booking-widget-loader.js"]');
		}
		return currentScript
			? (currentScript.getAttribute('data-store-clinic-id') ?? undefined)
			: undefined;
	}

	// 現在のscriptタグからdesignTokensを読み取る関数
	function getDesignTokensFromScript() {
		// 1. 現在実行中のscriptを取得（最も確実）
		let currentScript = document.currentScript;

		// 2. currentScriptが取得できない場合は判別用属性で検索
		if (!currentScript) {
			currentScript = document.querySelector('script[data-booking-widget-loader]');
		}

		// 3. フォールバック: URLパターンでの検索
		if (!currentScript) {
			currentScript = document.querySelector('script[src*="booking-widget-loader.js"]');
		}

		const designTokensAttr = currentScript?.getAttribute('data-design-tokens');
		if (designTokensAttr) {
			try {
				return JSON.parse(designTokensAttr);
			} catch (error) {
				console.warn('[BookingWidget] Failed to parse data-design-tokens:', error);
			}
		}
		return null;
	}

	// 開発環境かどうかを判定
	// 外部から window.BookingWidgetConfig.env で環境を注入可能（デフォルトは自動判定）
	// Capacitorアプリ等では env: 'development' を注入することで開発環境として動作する
	// ロジックの変更時は src/utils/environment.ts の isDevelopmentEnvironment() と同期すること
	function isDevelopment() {
		if (typeof window === 'undefined') {
			return false;
		}

		// 外部から環境が注入されている場合はそれを優先
		if (window.BookingWidgetConfig?.env) {
			return window.BookingWidgetConfig.env === 'development';
		}

		// Capacitorアプリ内ではデフォルトで本番扱い
		if (window.Capacitor) {
			return false;
		}

		const hostname = window.location.hostname;

		return (
			hostname === 'localhost' ||
			hostname === 'local.kireireport.com' ||
			hostname === 'widget-front.local.kireireport.com'
		);
	}

	function isStaging() {
		if (typeof window === 'undefined') {
			return false;
		}

		// 外部から環境が注入されている場合はそれを優先
		if (window.BookingWidgetConfig?.env) {
			return window.BookingWidgetConfig.env === 'staging';
		}

		const hostname = window.location.hostname;

		return (
			hostname === 'booking-chat-widget-staging.web.app' ||
			hostname === 'booking-chat-widget-staging.firebaseapp.com' ||
			hostname === 'staging.kireireport.com' ||
			hostname.endsWith('.staging.kireireport.com')
		);
	}

	// Firebase Hostingのドメイン名
	function getBaseUrl() {
		if (typeof window === 'undefined') {
			return 'https://booking-chat-widget.web.app/';
		}

		// 開発環境の判定
		if (isDevelopment()) {
			return 'https://widget-front.local.kireireport.com:5173/';
		}

		// Staging環境の判定
		if (isStaging()) {
			return 'https://booking-chat-widget-staging.web.app/';
		}

		// 本番環境
		return 'https://booking-chat-widget.web.app/';
	}

	const BASE_URL = getBaseUrl();

	const IS_DEVELOPMENT = isDevelopment();

	// エラーハンドリング用のログ関数
	function logError(message, error) {
		console.error('[BookingWidget] ' + message, error);
	}

	// デバッグログ関数（開発環境のみ出力）
	function logDebug(message, data) {
		if (IS_DEVELOPMENT) {
			console.log('[BookingWidget DEBUG] ' + message, data);
		}
	}

	// スクリプトプロパティをグローバル設定に保存
	window.BookingWidgetConfig = {
		...(window.BookingWidgetConfig || {}),
		clinicId: getClinicIdFromScript() || window.BookingWidgetConfig?.clinicId,
		// data-store-clinic-id が無いページでは前の院のIDを引き継がず undefined に落とす。
		// SPA遷移で前値が残ると誤った院に着地するため、アプリ home 着地のほうが安全（#552）。
		storeClinicId: getStoreClinicIdFromScript(),
		designTokens: getDesignTokensFromScript() ?? window.BookingWidgetConfig?.designTokens
	};

	logDebug('Widget loader initialized', {
		clinicId: window.BookingWidgetConfig.clinicId,
		baseUrl: BASE_URL
	});

	// ウィジェットが既にロードされているかチェック
	if (window.BookingWidgetLoaded) {
		logDebug('Widget already loaded, skipping');
		return;
	}

	logDebug('Starting widget load process');

	// ロード中フラグを設定
	window.BookingWidgetLoaded = true;

	async function loadWidget() {
		try {
			// latest-version.jsonをフェッチして最新のウィジェット本体のファイル名を取得
			const versionResponse = await fetch(BASE_URL + 'latest-version.json', {
				cache: 'no-cache'
				// Cache-Controlヘッダーを削除（CORS対応）
			});

			if (!versionResponse.ok) {
				throw new Error(`Failed to fetch version info: ${versionResponse.status}`);
			}

			const versionData = await versionResponse.json();

			if (!versionData.coreJs) {
				throw new Error('Missing coreJs in version data');
			}

			// ウィジェット本体のJSファイルを動的にロード
			const script = document.createElement('script');
			script.src = BASE_URL + versionData.coreJs;
			script.type = 'module'; // ES Module として読み込み
			script.async = true;
			script.defer = true;

			// スクリプトロードのエラーハンドリング
			script.onerror = function () {
				logError('Failed to load widget core script', { src: script.src });
			};

			script.onload = function () {
				// 成功ログは開発環境のみ出力
				if (IS_DEVELOPMENT) {
					console.log('[BookingWidget] Widget loaded successfully');
				}
			};

			// スクリプトをDOMに挿入
			const targetElement = document.head || document.body || document.documentElement;
			targetElement.appendChild(script);

			// CSSファイルもロードする場合
			if (versionData.coreCss) {
				const cssFiles = Array.isArray(versionData.coreCss)
					? versionData.coreCss
					: [versionData.coreCss];

				cssFiles.forEach((cssFile) => {
					const link = document.createElement('link');
					link.rel = 'stylesheet';
					link.href = BASE_URL + cssFile;
					link.onerror = function () {
						logError('Failed to load widget CSS', { href: link.href });
					};
					targetElement.appendChild(link);
				});
			}
		} catch (error) {
			logError('Failed to initialize widget', error);
		}
	}

	// DOMの準備が完了したらウィジェットをロード
	if (document.readyState === 'loading') {
		logDebug('DOM loading, waiting for DOMContentLoaded');
		document.addEventListener('DOMContentLoaded', loadWidget);
	} else {
		logDebug('DOM ready, loading widget immediately');
		loadWidget();
	}
})();
